import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody,
} from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import { Link } from 'react-router-dom';
import ReactImageFallback from 'react-image-fallback';
import { FALLBACK_ICON, LOGO_LARGE_WHITE } from '../../utils';

function SeeOfferPreview(props) {
  const {
    isOpen, onClose, clientLogo, coverImage, isClientLogoHide,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  return (
    <Modal isOpen={modal} className="modal-offer-detail">
      <ModalBody>
        <div className="offer-detail-modal-cover-wrapper">
          <div className="modal-cover">
            <img
              src={coverImage}
              alt="Offer Cover"
            />
          </div>
          <div className="modal-header-wrapper">
            <ModalHeader className="modal-blank-header" />
            <Link to="/dashboard" className="modal-offer-detail-logo">
              <ReactImageFallback
                src={LOGO_LARGE_WHITE}
                fallbackImage={FALLBACK_ICON}
                alt="BYGmusic"
              />
            </Link>
          </div>
        </div>
        <div className="modal-offer-detail-head preview-detail-head">
          <div className="offer-detail-cover-detail">
            {
              !isClientLogoHide
                ? (
                  <div className="modal-offer-detail-head-image">
                    <ReactImageFallback
                      src={clientLogo}
                      fallbackImage={FALLBACK_ICON}
                      alt="BYGmusic"
                    />
                  </div>
                )
                : (
                  <div className="modal-offer-detail-head-image transparent-background border-0" />
                )
            }

            <span className="offer-name"><span className="blank-space">&nbsp;</span></span>
            <h2><span className="blank-space">&nbsp;</span></h2>
            <p><span className="blank-space">&nbsp;</span></p>
            <p><span className="blank-space">&nbsp;</span></p>
            <p><span className="blank-space">&nbsp;</span></p>
          </div>
          <div className="offer-detail-cover-card">
            <span className="blank-space first-head">&nbsp;</span>
            <span className="blank-space first-para">&nbsp;</span>
            <span className="blank-space second-para">&nbsp;</span>
            <span className="blank-space btn-space-blank">&nbsp;</span>
          </div>
        </div>
        <div className="preview-offer-row">

          <div className="modal-offer-detail-timeline-row">
            <div className="timeline-box-detail-section">
              <div className="modal-offer-detail-timeline-head false">
                <h3>
                  <span className="blank-space">&nbsp;</span>
                </h3>
              </div>
              <div className="modal-offer-detail-timeline-data box-none">
                <p><span className="blank-space">&nbsp;</span></p>
                <p><span className="blank-space">&nbsp;</span></p>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <div className="preview-close-container">
        <span className="text">Cover Preview mode</span>
        <button type="button" onClick={toggle} className="btn btn-close">Close</button>
      </div>
    </Modal>
  );
}

SeeOfferPreview.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clientLogo: PropTypes.string,
  coverImage: PropTypes.string,
  isClientLogoHide: PropTypes.bool.isRequired,
};

SeeOfferPreview.defaultProps = {
  coverImage: null,
  clientLogo: null,
};

export default SeeOfferPreview;
